import React from 'react';
import './Community.css';

const Community = () => {
  return (
    <div className="community-page">
      <div className="container">
        <h1 className="section-title">X Community</h1>
        
        <div className="community-content">
          <p className="community-description">
            Join our community on X (formerly Twitter) to share your action figures, 
            get inspiration, and connect with other creators!
          </p>
          
          <a href="https://x.com/i/communities/1912529619669889411" target="_blank" rel="noopener noreferrer" className="social-link">
            <i className="fa fa-twitter"></i> Follow us on X
          </a>
          
          <div className="hashtag-section">
            <h3>Share your creations with hashtag:</h3>
            <div className="hashtag">#ActionFigureSol</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Community; 